import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconFlipVertical';
/** Renders an SVG icon. */
const SvgFlipVertical = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M22.586 4C24.368 4 25.26 6.154 24 7.414l-5 5a2 2 0 0 1-1.414.586h-3.172A2 2 0 0 1 13 12.414l-5-5C6.74 6.154 7.632 4 9.414 4zM9.414 6l5 5h3.172l5-5zm8.172 15h-3.172l-5 5h13.172zm-8.172 7C7.632 28 6.74 25.846 8 24.586l5-5A2 2 0 0 1 14.414 19h3.172a2 2 0 0 1 1.414.586l5 5c1.26 1.26.368 3.414-1.414 3.414zM6.833 15a1 1 0 1 1 0 2H5a1 1 0 1 1 0-2zm7.334 0a1 1 0 0 1 0 2H10.5a1 1 0 1 1 0-2zm7.333 0a1 1 0 1 1 0 2h-3.667a1 1 0 0 1 0-2zm5.5 0a1 1 0 1 1 0 2h-1.833a1 1 0 1 1 0-2z"
      />
    </svg>
  );
};
SvgFlipVertical.displayName = displayName;
export default SvgFlipVertical;
